module.exports = __webpack_public_path__ + "img/img_2.cb9852c9.png";